angular.module("acl.common.input", ["acl.common.localize", "acl.visualizer.formatters", "acl.visualizer.model.field"]);
